import { CL_APPROVED } from "codes";
import type { CreditLimit } from "types";

/** Client-facing CL status; internal approval wins when public status lags. */
export const resolveEffectiveCreditLimitStatus = (
  creditLimit?: Pick<CreditLimit, "status" | "internal_status"> | null,
): string | undefined => {
  if (!creditLimit) {
    return undefined;
  }

  const status = String(creditLimit.status ?? "");
  const internalStatus = String(creditLimit.internal_status ?? "");

  if (
    status.toUpperCase() === CL_APPROVED ||
    internalStatus.toUpperCase() === CL_APPROVED
  ) {
    return CL_APPROVED;
  }

  return status || undefined;
};

export const withEffectiveCreditLimitStatus = <
  T extends Pick<CreditLimit, "status" | "internal_status">,
>(
  creditLimit?: T | null,
): T | undefined => {
  if (!creditLimit) {
    return undefined;
  }

  const effectiveStatus = resolveEffectiveCreditLimitStatus(creditLimit);
  if (!effectiveStatus || effectiveStatus === creditLimit.status) {
    return creditLimit;
  }

  return { ...creditLimit, status: effectiveStatus };
};
